import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-painting-detail',
  templateUrl: './painting-detail.component.html',
  styleUrls: ['./painting-detail.component.sass']
})
export class PaintingDetailComponent implements OnInit {
  producerDocId;

  paintingDocId;
  paintingDoc;
  paintingCol;
  pictureCol;
  
  coverPhoto: string = "./assets/img/no-cover.png";
  profilePhoto: string = "./assets/img/no-logo.png";
  //email: string = 'moses@pngl.com';

  logoImage: string = "./assets/img/no-logo.png";
  coverImage: string = "./assets/img/no-cover.png";
  

  constructor(
    public db: FirestoreService,
    public route: Router,
    public aroute: ActivatedRoute
    ) {}

  ngOnInit(): void {
    this.paintingDocId = this.aroute.snapshot.paramMap.get('id');
    this.paintingDoc = this.db.getMainDoc('storeproducts', this.paintingDocId); 
    this.pictureCol = this.db.getSubCol('storeproducts', this.paintingDocId, 'productPictures');
    //console.log(this.pictureCol);
    this.db.getDocId('storeproducts', this.paintingDocId)
    .then(data=>{
      this.producerDocId = data.ownerDocId;
      this.paintingCol = this.db.getMainColWhere('storeproducts', 'ownerDocId', this.producerDocId);
    })
  }

  scrollToTop(){
    this.route.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });  
  }
  
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
  }

  routeToDetailPage(docId){
    this.route.navigateByUrl('painting/'+docId);
  };
  routePaintingDetailPage(docId){
    
    this.route.navigateByUrl('painting/'+docId)
    .then(res =>{
      this.reloadComponent()
    })
  }

}
